import { WizCommand } from "@wizeoo/akm-component-lib";
import { BasicCriteria, BasicScenario, Matrix, MatrixWrapper } from "@wizeoo/akm-message-lib";
import { Model } from '../../model/model';
import { WIZ_COMMAND_METHOD } from "@wizeoo/akm-core-lib";
import { ExternalAPI } from '../../model/external-api';
import { MatrixDataLoad } from "../../vo/matrix/matrix.dataload";
import { MatrixVO } from "@wizeoo/akm-compute-lib";
import { dA } from "@fullcalendar/core/internal-common";

/**
 * Commande REST de recherche des matrices de données
 */
export class MatrixCommand extends WizCommand<MatrixWrapper> {

    protected model: Model = null;

    public method: string;
    public matrix: Matrix;
    public matrixVO: MatrixVO;
    public dataload: MatrixDataLoad;

    constructor(model: Model) {
      super();
      this.model = model;
    }

    /** retourne un wrapper pre-alimenté */
    public matrixWrapper(): MatrixWrapper {
        const wrapper: MatrixWrapper = new MatrixWrapper();
        wrapper.criteria = new BasicCriteria();
        wrapper.criteria.manageDeprecated = true;
        wrapper.criteria.manageDeleted = true;
        wrapper.criteria.domain = this.model.domainCode;
        wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
        wrapper.scenario = new BasicScenario();
        wrapper.scenario.languageCode = this.model.currentLocaleCode;
        return wrapper;
    }

    /** configuration du chargement */
    public findForDataload(dataload: MatrixDataLoad, viewCallback?: Function): MatrixCommand {
        const wrapper: MatrixWrapper = this.matrixWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.FIND;
        this.method = 'dataload';
        this.dataload = dataload;
        this.configureRemote(ExternalAPI.MATRIX_API, wrapper, viewCallback);
        return this;
    }

    /** configuration du chargement */
    public getForDataload(matrix: Matrix, viewCallback?: Function): MatrixCommand {
        const wrapper: MatrixWrapper = this.matrixWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.GET;
        wrapper.entity = matrix;
        this.method = 'load';
        this.matrix = matrix;
        this.configureRemote(ExternalAPI.MATRIX_LOAD_DATAS, wrapper, viewCallback);
        return this;
    }


    /** configuration du chargement */
    public find(viewCallback?: Function): MatrixCommand {
        const wrapper: MatrixWrapper = this.matrixWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.FIND;
        this.method = wrapper.method;
        this.configureRemote(ExternalAPI.MATRIX_API, wrapper, viewCallback);
        return this;
    }

    /** configuration du chargement */
    public get(matrix: MatrixVO, viewCallback?: Function): MatrixCommand {
        const wrapper: MatrixWrapper = this.matrixWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.GET;
        wrapper.entity = matrix.source;
        this.method = wrapper.method;
        this.matrixVO = matrix;
        this.configureRemote(ExternalAPI.MATRIX_LOAD_DATAS, wrapper, viewCallback);
        return this;
    }

    /** getter sur la matrice ROWS en local */
    public getLocalData(matrix: MatrixVO, viewCallback?: Function): MatrixCommand {
        
      
      const wrapper: MatrixWrapper = this.matrixWrapper();
        wrapper.method = WIZ_COMMAND_METHOD.GET;
        wrapper.entity = matrix.source;
        this.method = wrapper.method;
        this.matrixVO = matrix;
        this.configureRemote(ExternalAPI.MATRIX_LOAD_DATAS, wrapper, viewCallback);
        return this;
    }


    /** sur retour de find, construction */
    public wizResult() {
        super.wizResult();
        if (!!this.result) {
          if(this.method === 'dataload') {
            // on va gérer dans le matrixSyncService
          } else if(this.method === 'load') {
            // on va gérer dans le matrixSyncService
          } else if(this.method === WIZ_COMMAND_METHOD.FIND) {
            this.model.matrixEngine.feedMatrix(this.result.entities);
          } else if(this.method === WIZ_COMMAND_METHOD.GET) {
            console.log('get matrix', this.result);
            this.matrixVO.source = this.result.entity;
            this.matrixVO.loaded = true;
            // this.callback(this.matrix);
          }
//        if (this.result?.entities) {
            
/*            this.dataLoad.matrix = [];
            this.result.forEach((m: MatrixLite) => {
        this.dataLoad.matrix.
      });*/
        }
    }

}
